import { useEffect } from 'react';

// Уведомление закрывается само: зелёное через 5 секунд, ошибки и предупреждения висят дольше,
// чтобы их успели прочитать. Новое уведомление отсчитывает своё время заново.
export const ALERT_MS = 5000;
export const ALERT_SLOW_MS = 12000;

export default function useAutoHideAlert(alert, hideAlert) {
  useEffect(() => {
    if (!alert || !alert.show) return undefined;
    const slow = alert.severity === 'error' || alert.severity === 'warning';
    const timer = setTimeout(
      () => hideAlert({ ...alert, show: false }),
      slow ? ALERT_SLOW_MS : ALERT_MS
    );
    return () => clearTimeout(timer);
  }, [alert, hideAlert]);
}
